import { word } from "@modules/core/utils/i18n"
import { useCountriesListArray } from "@modules/language/utils/countries"
import { ProfileLabelVisibility } from "@modules/profile/myProfile/components/profileLabelVisibility"
import { ProfileFormTabProps } from "@modules/profile/myProfile/profileFormikType"
import { FormikInput } from "@modules/ui/components/formikInput"
import { HUText } from "@modules/ui/components/huText"
import { HUStack } from "@modules/ui/components/layout"

export const BiographyForm: React.FC<ProfileFormTabProps> = ({ isFormFieldInValid, getFormErrorMessage, formik }) => {
  const countriesOptions = useCountriesListArray()

  return (
    <div className="flex flex-grow-1 flex-column justify-content-start mt-6 gap-4 px-4">
      <HUText fontStyle="TM" className="align-self-center mb-4">
        {word("profile.form.biography.title")}
      </HUText>

      {/* Biography input */}
      <HUStack gap={6}>
        <ProfileLabelVisibility
          label={word("profile.form.description.label")}
          name="biography"
          isInvalid={isFormFieldInValid("biography")}
        />
        <FormikInput
          type="textarea"
          textareaProps={{ className: "flex-1", maxLength: 500, autoResize: true, rows: 8 }}
          getFieldProps={formik.getFieldProps}
          isInvalid={isFormFieldInValid("biography")}
          name="biography"
          error={getFormErrorMessage("biography")}
          placeHolder={word("profile.form.description.label")}
        />
      </HUStack>

      {/* Job input */}
      <HUStack gap={6}>
        <ProfileLabelVisibility
          label={word("profile.form.job.label")}
          name="job"
          isInvalid={isFormFieldInValid("job")}
          displayVisibleToggle
          visibility={formik.getFieldProps("jobVisibility").value}
          onToggleVisibility={() => formik.setFieldValue("jobVisibility", !formik.getFieldProps("jobVisibility").value)}
        />
        <FormikInput
          textProps={{ className: "flex-1" }}
          getFieldProps={formik.getFieldProps}
          isInvalid={isFormFieldInValid("job")}
          name="job"
          error={getFormErrorMessage("job")}
          placeHolder={word("profile.form.job.placeholder")}
        />
      </HUStack>

      {/* Nationality input */}
      <HUStack gap={6}>
        <ProfileLabelVisibility
          label={word("profile.form.nationality.label")}
          name="nationality"
          isInvalid={isFormFieldInValid("nationality")}
          displayVisibleToggle
          visibility={formik.getFieldProps("nationalityVisibility").value}
          onToggleVisibility={() =>
            formik.setFieldValue("nationalityVisibility", !formik.getFieldProps("nationalityVisibility").value)
          }
        />
        <FormikInput
          flex
          isRequiredInput
          type="autocomplete"
          isInvalid={isFormFieldInValid("nationality")}
          getFieldProps={formik.getFieldProps}
          setFieldValue={formik.setFieldValue}
          name="nationality"
          error={getFormErrorMessage("nationality")}
          placeHolder={word("global.country.label")}
          autocompleteProps={{
            className: "w-full",
            suggestions: countriesOptions.map((countryOption) => countryOption.label),
            value: countriesOptions.find((countryOption) => countryOption.code === formik.values.nationality)?.label,
            onSelect: (e) => {
              const foundCountry = countriesOptions.find((countryOption) => countryOption.label === e.value)
              formik.setFieldValue("nationality", foundCountry?.code)
            },
            onBlur: (e) => {
              if (e.target) {
                const foundCountry = countriesOptions.find((countryOption) => countryOption.label === e.target.value)
                formik.setFieldValue("nationality", foundCountry?.code)
              }

              if (formik.handleBlur) formik.handleBlur(e, "country")
            },
            forceSelection: true,
          }}
        />
      </HUStack>
    </div>
  )
}
